import React from "react";
import discoverimg from "../../../assets/images/Discover.png";
import treesimg from "../../../assets/images/trees_cloud.png";
import safetyimg from "../../../assets/images/Safety.png";

const FeatureIcons = () => {
  return (
    <div className="flex justify-between gap-5 items-center w-full max-w-4xl mx-auto p-4 py-20  max-md:flex-col max-md:space-y-4">
      <div className="flex flex-col items-center text-center p-3 border border-gray-200 rounded-lg shadow-sm bg-gradient-to-t from-red-200 to-violet-100 dark:border-gray-700 velvelt-box-1" style={{width: "400px", height: "240px"}}>
        <div className="mb-2  rounded-full  w-24 h-24 flex items-center justify-center">
          <img
            src={discoverimg}
            alt="Discover"
            className="w-24 h-24 object-cover object-center"
          />
        </div>
        <span className="text-[#730000] font-bold mt-2 text-2xl">Sign Up</span>
        <p className="mt-2 text-gray-700 text">
          Register for free and share your complete profile for matchmaking
        </p>
      </div>


      <div className="flex flex-col items-center text-center  p-3 border border-gray-200 rounded-lg shadow-sm bg-gradient-to-t from-red-200 to-violet-100 dark:border-gray-700 velvelt-box-2">
        <div className="mb-2  rounded-full  w-24 h-24 flex items-center justify-center">
          <img
            src={treesimg}
            alt="Save time & money"
            className="w-24 h-24 object-cover rounded-full"
          />
        </div>
        <span className="text-[#730000] font-bold mt-2 text-2xl">Explore</span>
        <p>Browse a wide list of profiles on our platform</p>
      </div>

      <div className="flex flex-col items-center text-center  p-3 border border-gray-200 rounded-lg shadow-sm bg-gradient-to-t from-red-200 to-violet-100 dark:border-gray-700 w-50 velvelt-box-3" style={{width: "400px", height: "240px"}}>
        <div className="mb-2 rounded-full  w-24 h-24 flex items-center justify-center">
          <img
            src={safetyimg}
            alt="Safety & support"
            className="w-24 h-24 object-cover rounded-full"
          />
        </div>
        <span className="text-[#730000] font-bold mt-2 text-2xl">Connect</span>
        <p>Connect with your prospect spouse and begin your forever</p>
      </div>
    </div>
  );
};

export default FeatureIcons;
